import React from 'react';
import { ReactComponent as CheckCircleFilled } from 'assets/icons/New/check-circle-outlined.svg';
import { ReactComponent as CheckCircleGreenFilled } from 'assets/icons/New/check-circle-green-outlined.svg';
import { ReactComponent as ExclamationCircleFilled } from 'assets/icons/New/exclamation.svg';
import * as Yup from 'yup';
import GeneralInformation from './SubForms/GeneralInformation';
import TestData from './SubForms/TestData';
import LaboratoryInformation from './SubForms/LaboratoryInformation';
import DocNotifiedBodyInformation from './SubForms/Doc/NotifiedBodyInformation';

const EmptyMessage = true;

export const SUB_FORMS = [
  {
    label: 'General Information',
    value: 'general',
    children: <GeneralInformation />,
    isApplicable: ({ type }) => {
      return ['gcc', 'cpc', 'doc'].includes(type);
    },
    validateSchema: (type) => {
      if (type === 'doc') {
        return Yup.object().shape({
          general: Yup.object({
            productName: Yup.string()
              .nullable()
              .required(EmptyMessage),
            productModel: Yup.string()
              .nullable()
              .required(EmptyMessage),
            productPictures: Yup.array()
              .nullable()
              .required(EmptyMessage),
            companyName: Yup.string()
              .nullable()
              .required(EmptyMessage),
            companyAddress: Yup.string()
              .nullable()
              .required(EmptyMessage),
            companyPhone: Yup.object({
              phone: Yup.string()
                .nullable()
                .required(EmptyMessage),
              code: Yup.string().required(EmptyMessage),
            }),
            companyContactEmail: Yup.string()
              .email('Invalid email')
              .required(EmptyMessage),
            companyLogo: Yup.array()
              .nullable()
              .required(EmptyMessage),
          }),
        });
      }
      return Yup.object().shape({
        general: Yup.object({
          productName: Yup.string()
            .nullable()
            .required(EmptyMessage),
          productModel: Yup.string()
            .nullable()
            .required(EmptyMessage),
          companyName: Yup.string()
            .nullable()
            .required(EmptyMessage),
          companyPhone: Yup.object({
            phone: Yup.string()
              .nullable()
              .required(EmptyMessage),
            code: Yup.string().required(EmptyMessage),
          }),
          companyAddress: Yup.string()
            .nullable()
            .required(EmptyMessage),
          contactName: Yup.string()
            .nullable()
            .required(EmptyMessage),
          contactAddress: Yup.string()
            .nullable()
            .required(EmptyMessage),
          contactPhone: Yup.object({
            phone: Yup.string()
              .nullable()
              .required(EmptyMessage),
            code: Yup.string().required(EmptyMessage),
          }),
          contactEmail: Yup.string()
            .email('Invalid email')
            .required(EmptyMessage),
          manufactureDate: Yup.string()
            .nullable()
            .required(EmptyMessage),
          manufacturePlace: Yup.string()
            .nullable()
            .required(EmptyMessage),
        }),
      });
    },
  },
  {
    label: 'Test Data',
    value: 'testData',
    children: <TestData />,
    isApplicable: ({ type }) => {
      return ['gcc', 'cpc', 'doc'].includes(type);
    },
    validateSchema: (type) => {
      if (type === 'doc') {
        return Yup.object().shape({
          testData: Yup.array()
            .of(
              Yup.object({
                testItemId: Yup.mixed()
                  .nullable()
                  .required(EmptyMessage),
                legislation: Yup.string()
                  .nullable()
                  .required(EmptyMessage),
              }).required(EmptyMessage)
            )
            .required(EmptyMessage),
        });
      }
      return Yup.object().shape({
        testData: Yup.array()
          .of(
            Yup.object({
              testItemId: Yup.mixed().required(EmptyMessage),
              serviceProvider: Yup.object({
                name: Yup.string()
                  .nullable()
                  .required(EmptyMessage),
              }),
            }).required(EmptyMessage)
          )
          .required(EmptyMessage),
      });
    },
  },
  {
    label: 'Notified Body Information',
    value: 'notifiedBodyInformation',
    isApplicable: ({ type }) => {
      return ['doc'].includes(type);
    },
    children: <DocNotifiedBodyInformation />,
  },
  {
    label: 'Laboratory Information',
    value: 'laboratory',
    children: <LaboratoryInformation />,
    isApplicable: ({ type }) => {
      return ['gcc', 'cpc'].includes(type);
    },
    validateSchema: (type) => {
      if (type === 'doc') return null;
      return Yup.object().shape({
        laboratory: Yup.array()
          .of(
            Yup.object({
              phoneObj: Yup.object({
                phone: Yup.string()
                  .nullable()
                  .required(EmptyMessage),
                code: Yup.string().required(EmptyMessage),
              }),
              address: Yup.string()
                .nullable()
                .required(EmptyMessage),
              area: Yup.string()
                .nullable()
                .required(EmptyMessage),
            })
          )
          .required(EmptyMessage),
      });
    },
  },
];

export const STATUS_ICONS = {
  default: <CheckCircleFilled />,
  success: <CheckCircleGreenFilled />,
  error: <ExclamationCircleFilled />,
};
